import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import './Testi.css'
import { GoArrowLeft, GoArrowRight } from "react-icons/go";
import { Col, Container, Row } from "react-bootstrap";
import { FaStar } from "react-icons/fa6";
import { Link } from "react-router-dom";
const Testimo = () => {
  const testimonials = [
    {
      name: "Ashish Malhorta",
      cat: "Patient",
      image: "/Images/testi-one.jpeg",
      testimonial:
        "I’m very satisfied with my surgery results. The surgeon was kind and humble, clearly explaining my options. I’m grateful for her expertise, and the staff was always polite and cooperative.",
      rating: 4,
    },
    {
      name: "Vivan Sharma",
      cat: "Patient",
      image: "/Images/testi-three.jpeg",
      testimonial:
        "Initially, I felt a bit apprehensive, but after meeting the staff and the doctor, I felt more at ease and optimistic about the rhinoplasty. After the surgery, I was extremely satisfied and happy with my new nose.",
      rating: 5,
    },
    {
      name: "Shruti Kumari",
      cat: "Patient",
      image: "/Images/testi-two.jpeg",
      testimonial:
        "The doctor is excellent and a compassionate person. They are approachable and attentive to patients’ needs, with a warm staff that supports their expert guidance in enhancing confidence.",
      rating: 5,
    },
   
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };
  return (
    <div className="test_monial_home_ctontainers">
      <div className="testimonial_home_main">
        <Container>
          <Row>
            <Col lg={6} xs={12} sm={12}>
              <div className="wpb_wrapper">
                <div className="about_us_second_home_wrapper">
                  <h3 className="heading_testi">How healthy are you</h3>
                </div>
                <div className="tm-spacer" id="tm-spacer-678c162ae9745" />
                <div
                  className="about_us_second_home_wrapper"
                  id="tm-heading-678c162ae9857"
                >
                  <div className="heading_sec_testi">
                    Your health is important…
                  </div>
                </div>
                <div className="tm-spacer" id="tm-spacer-678c162ae9cb5" />
              </div>
            </Col>
            <Col lg={6} xs={12} sm={12}>
              <div
                className="tm-button-wrapper tm-animation move-upanimate"
                id="tm-button-678c162aea64a"
              >
                <Link to='/contact-us' className="testimonial_home_btn">
                  <span className="button-text" data-text="Get a free report">
                    Contact Us Now{" "}
                  </span>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="testi_home_main_sec">
        <Container>
          {/* <Col> */}
          <div className="testi_home_marginn">
            <Row>
              {/* <div className="swiper-container">
                  <Swiper
                    slidesPerView={3}
                    spaceBetween={30}
                    onSlideChange={(swiper) =>
                      setCurrentIndex(swiper.activeIndex)
                    } // Update index on slide change
                    className="swiper-wrapper"
                  > */}
              {testimonials.map((testimonial, index) => (
                <Col lg={4} style={{ position: "relative" }}>
                  {/* <SwiperSlide key={index} className="swiper-slide"> */}
                  <div className="testimonial-item">
                    <div className="post-thumbnail">
                      <img src={testimonial.image} />
                    </div>
                    <div className="testimonial-content">
                      <h6 className="testimonial-name">{testimonial.name}</h6>
                      <div className="testimonial-by-line">
                        {testimonial.cat}
                      </div>
                      <div className="testimonial-desc">
                        <p className="p1">
                          {testimonial.testimonial}
                          {/* <span className="s1">This theme&nbsp;</span>
                                <a>@healsoul</a>
                                <span className="s1">
                                  {" "}
                                  have more power than I think in the first
                                  place. It helps connect patients with
                                  potential doctor or caregiver.
                                </span> */}
                        </p>
                      </div>
                      <div className="testimonial-rating">
                        <FaStar />

                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
              {/* </Swiper>
                  </Row>
                </div> */}
            </Row>
          </div>
          {/* </Col> */}
        </Container>
      </div>
    </div>
  );
};

export default Testimo;
